import React, { forwardRef, lazy, memo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectAll, selectPageStatus } from "../../store/slices/pageSlice";
import { useParams } from "react-router-dom";
import { setLanguage } from "../../store/slices/languageSlice";
import { motion } from "framer-motion";
import { selectLogos } from "../../store/slices/configSlice";
import { motionContainer } from "../../../utils/GlobalAnimations";
import _ from "lodash";
import PageLoading from "../../components/loader/PageLoading";

//import WidgetRegister from "../../components/widgets/WidgetsRegister";
const WidgetRegister = lazy(() =>
  import("../../components/widgets/WidgetsRegister")
);

const PageTemplateI = forwardRef((props, ref) => {
  const dispatch = useDispatch();
  const data = useSelector(selectAll);
  const status = useSelector(selectPageStatus);

  const params = useParams();

  useEffect(() => {
    if (params.lang) {
      dispatch(setLanguage(params.lang));
    }
  }, [params.lang]);

  if (status === "pending")
    return (
      <motion.div
        initial="hidden"
        animate="visible"
        exit={{ opacity: 0, transition: { duration: 1 } }}
        variants={{ visible: { transition: { staggerChildren: 0.3 } } }}
      >
        <PageLoading />
      </motion.div>
    );

  return (
    <motion.div
      className="interior-design"
      style={props.style}
      variants={motionContainer}
      initial="hidden"
      animate="show"
    >
      {data.map((dt, _index) => {
        const { content, widget_content, post_content_id, ...parent } = dt;
        const { type_widget } = content;

        return (
          <WidgetRegister
            key={post_content_id}
            type={type_widget}
            items={widget_content}
            parent={{ ...dt, ...parent, ...content }}
          />
        );
      })}
    </motion.div>
  );
});

export default memo(PageTemplateI);
